// The "Fundamental Questions" categories this panel actually answers --
// backed by AnalysisEngine.fundamental_questions_summary() -- in display
// order. Causation, Optimization, Prediction, and Comparing Alternatives
// (the rest of the Sacks et al. 1989 framework) are deliberately left out:
// this tool doesn't run a causal model, a response-surface search, a
// regression/surrogate model, or a named-policy hypothesis test, and
// showing a card for them would either overclaim or just say "not
// answered" for four cards with nothing else to offer.
export const FUNDAMENTAL_QUESTIONS = [
  {
    key: "importance",
    title: "Importance",
    question: "Which factors matter most, and how much?",
    tabHint: "Main Effects / Parameter Importance Ranking",
  },
  {
    key: "interaction",
    title: "Interaction",
    question: "Does one factor's effect depend on another's level?",
    tabHint: "Interaction Effects",
  },
  {
    key: "predictive_distribution",
    title: "Predictive Distribution",
    question: "What's the full range of outcomes to expect?",
    tabHint: "Percentile Analysis",
  },
  {
    key: "risk",
    title: "Risk / Extreme Behavior",
    question: "How severe could an extreme outcome be?",
    tabHint: "Percentile Analysis",
  },
  {
    key: "bottlenecks",
    title: "Bottlenecks / Constraints",
    question: "What's actually limiting performance?",
    tabHint: "Resource Utilization",
  },
];

export function getAvailableFundamentalQuestions(fundamentalQuestions) {
  if (!fundamentalQuestions) {
    return [];
  }
  return FUNDAMENTAL_QUESTIONS.filter((q) => fundamentalQuestions[q.key]);
}

export const DESIGN_TYPE_LABELS = {
  single_run: "Single Run",
  factorial: "Factorial",
  factorial_partial: "Factorial (partial grid)",
  monte_carlo: "Monte Carlo",
  mixed: "Mixed Design",
};

export const DESIGN_TYPE_SEVERITY = {
  single_run: "info",
  factorial: "success",
  factorial_partial: "warning",
  monte_carlo: "success",
  mixed: "info",
};

export const RESPONSE_VARIABLE_LABELS = {
  throughput: "Throughput",
  completion_rate: "Completion rate",
  entity_arrival_counts: "Entity arrival counts",
  entity_total_time: "Entity total time",
};
